export default {
  setFeedBackTypes(state, data) {
    state.feedBackTypes = data;
  },
  setFeedBackTypeCode(state, data) {
    state.feedBackTypeCode = data;
  },

  setFeedBack(state, data) {
    state.feedBack = data;
  },
  setFeedBackItem(state, data) {
    state.feedBackItem = data;
  },
  setFeedBackCode(state, data) {
    state.feedBackCode = data;
  },
  setFeedBackId(state, data) {
    state.feedBackId = data;
  },
  setFeedbackAnswerId(state, data) {
    state.feedbackAnswerId = data;
  },

  setFeedbackQuestion(state, data) {
    state.feedbackQuestion = data;
  },

  setFeedbackAnswers(state, data) {
    state.feedbackAnswers = data;
  },

  setFeedbackAnswer(state, data) {
    state.feedbackAnswer = data;
  },

  setFeedbackQuestionOptions(state, data) {
    state.feedbackQuestionOptions = data;
  },
  setFeedbackQuestionOption(state, data) {
    state.feedbackQuestionOption = data;
  },

  setPersonClubGroup(state, data) {
    state.personClubGroup = data;
  },
  setPersonClubGroupCode(state, data) {
    state.personClubGroupCode = data;
  },
  setPersonClubByMobile(state, data) {
    state.personClubByMobile = data;
  },
  setPersonClubModal(state, data) {
    state.personClubModal = data;
  },

  setSalesChannel(state, data) {
    state.salesChannel = data;
  },
  setSalesChannelCode(state, data) {
    state.salesChannelCode = data;
  },

  setIntroducedType(state, data) {
    state.introducedType = data;
  },
  setIntroducedTypeCode(state, data) {
    state.introducedTypeCode = data;
  },

  setCustomerTag(state, data) {
    state.customerTag = data;
  },
  setCustomerTagCode(state, data) {
    state.customerTagCode = data;
  },

  setOccasionType(state, data) {
    state.occasionType = data;
  },
  setOccasionTypeCode(state, data) {
    state.occasionTypeCode = data;
  },

  setDeliveryMethods(state, data) {
    state.deliveryMethods = data;
  },
  setDeliveryMethodCode(state, data) {
    state.deliveryMethodCode = data;
  },

  setPaymentMethods(state, data) {
    state.paymentMethods = data;
  },
  setPaymentMethodCode(state, data) {
    state.paymentMethodCode = data;
  },

  setDiscounts(state, data) {
    state.discounts = data;
  },
  setDiscount(state, data) {
    state.discount = data;
  },
  setDiscountCode(state, data) {
    state.discountCode = data;
  },
  setValidateDiscountCode(state, data) {
    state.validateDiscountCode = data;
  },

  setPersonsClub(state, data) {
    state.personsClub = data;
  },
  setPersonClub(state, data) {
    state.personClub = data;
  },
  setPersonClubCode(state, data) {
    state.personClubCode = data;
  },
  setPersonSearchSuccess(state, data) {
    state.personSearchSuccess = data;
  },
  setPersonClubSearch(state, data) {
    state.personClubSearch = data;
  },

  setSmsSetting(state, data) {
    state.smsSetting = data;
  },
  setSmsSettingById(state, data) {
    state.smsSettingById = data;
  },
  setProcesses(state, data) {
    state.processes = data;
  },
  setProcess(state, data) {
    state.process = data;
  },
  setProcessCode(state, data) {
    state.processCode = data;
  },

  setScoreTransaction(state, data) {
    state.scoreTransaction = data;
  },
  setCreditTransaction(state, data) {
    state.creditTransaction = data;
  },
  setValidateCreditCode(state, data) {
    state.validateCreditCode = data;
  },

  setPurchases(state, data) {
    state.purchases = data;
  },
  setPurchase(state, data) {
    state.purchase = data;
  },

  setPersonClubGrades(state, data) {
    state.personClubGrades = data;
  },
  setPersonClubGradeCode(state, data) {
    state.personClubGradeCode = data;
  },

  setPersonClubPurchase(state, data) {
    state.personClubPurchase = data;
  },
  setPurchaseSearchByMobile(state, data) {
    state.purchaseSearchByMobile = data;
  },

  setCustomerPurchaseReport(state, data) {
    state.customerPurchaseReport = data;
  },

  setScoreSummery(state, data) {
    state.scoreSummery = data;
  },

  setMostCustomerRegistrations(state, data) {
    state.mostCustomerRegistrations = data;
  },

  setRequirementProfile(state, data) {
    state.requirementProfile = data;
  },

  setApiKeyAccess(state, data) {
    state.apiKeyAccess = data;
  },

  setFeedbackReport(state, data) {
    state.feedbackReport = data;
  },
  setFeedbackDetailReport(state, data) {
    state.feedbackDetailReport = data;
  },
  setPersonClubFeedbackReport(state, data) {
    state.personClubFeedbackReport = data;
  },
  setPersonClubFeedbackLog(state, data) {
    state.personClubFeedbackLog = data;
  },
  setAnswerPersonClub(state, data) {
    state.answerPersonClub = data;
  },
};
